.wrap {
  display: grid;
  gap: 10px;
}

/* 14px high, segments share the width by their values, 2px of surface between neighbours. */
.bar {
  display: flex;
  gap: 2px;
  height: 14px;
}

.segment {
  min-width: 4px;
  height: 100%;
  border-radius: 3px;
  outline: none;
  transition: opacity var(--dur-1) var(--ease-std);
}

.segment:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}

.dim {
  opacity: 0.4;
}

/* A segment that opens a receipt is a button, so it is never narrower than the 24px target minimum
   (a 3% share on a 600px bar would be 18px). The printed figures and the legend carry the exact
   shares; the bar is a picture of proportion, not the figure. */
.openable {
  cursor: pointer;
  min-width: 24px;
}

/* The rows share four tracks (swatch, name, value, share), so the values end on one line and the shares
   on another whether or not a row has a share (alignment audit, 2026-11-03). */
.legend {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) max-content max-content;
  gap: 2px 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: center;
  column-gap: 8px;
  min-height: 22px;
  padding: 0 6px;
  border-radius: var(--radius-ctl);
  color: var(--ink-2);
  font-size: var(--t-min);
}

.itemOn {
  background: var(--panel-2);
}

.dotMark {
  width: 10px;
  height: 10px;
  border-radius: 3px;
}

.itemLabel {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.itemValue {
  justify-self: end;
  color: var(--ink);
  font-weight: 650;
  text-align: right;
}

/* The value of a part that opens its receipt: a button that reads as the figure, at least 24px tall. */
.itemButton {
  min-height: 24px;
  padding: 0 4px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: none;
  font: inherit;
  font-weight: 650;
  cursor: pointer;
}

.itemButton:hover {
  text-decoration: underline;
}

.itemButton:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.itemShare {
  min-width: 44px;
  color: var(--muted);
  text-align: right;
}

.tipLine {
  display: block;
  font-variant-numeric: lining-nums tabular-nums;
}

@media (prefers-reduced-motion: reduce) {
  .segment {
    transition: none;
  }
}
